import { IMpnRequest, IPisRequest } from "../../../types/data.interface";
import { buildPisRequest } from "../../../helpers/pis-request.helper";
import { Predicates } from "../../../libraries/predicates/predicates";
import { updatePisRequest } from "../../../hooks/usePisRequest";
import { CreateMpnActionTypes, CreateMpnState } from "../states/create/data";
import { mpnRequestDto } from "./mpnRequestDto";
import { AxiosInstance } from "axios";
import { toast } from "react-toastify";


type onApproveProps = {
  state: CreateMpnState;
  onSetValues: (...args: any[]) => void;
  axios: AxiosInstance;
  username: any;
  onSetSearchParams: (...args: any[]) => void;
  onNavigate: (route: string) => void;
  onFinalizeSkuCreationProcess: (...args: any[]) => void;
  onSendPisRequestEmailsBasedOnAction: (...args: any[]) => void;
};

export const onApproveMpn = async ({axios, state, username, onSetValues, onSetSearchParams, onNavigate, onSendPisRequestEmailsBasedOnAction, onFinalizeSkuCreationProcess}:onApproveProps) => {

  const formattedMpnRequest: IMpnRequest = mpnRequestDto(state, username);



  //if (Predicates.isNullOrUndefined(selectedTcc) && (requestorMarket?.region?.name !== "APAC")) {
  //   toast.error(
  //     "You need to select a TCC in order to Approve the request. Please fill that information in the 'SKU Hierarchy' step.",
  //   );
  //   return;
  // }

  onSetValues(CreateMpnActionTypes.SET_UNSAVED_CHANGES, false);
  onSetValues(CreateMpnActionTypes.SET_IS_SAVING_OR_SUBMITING, true);

  const response = await updatePisRequest({
    id: Number(formattedMpnRequest.id),
    requestData: { ...formattedMpnRequest, status: "APPROVED" },
    axios,
  });
  onSetValues(CreateMpnActionTypes.SET_IS_SAVING_OR_SUBMITING, false);

  if (response) {
    onSetValues(CreateMpnActionTypes.SET_UNSAVED_CHANGES, false);

    toast.success(
      `MPN Request ${formattedMpnRequest.pis_request_id} approved!`,
    );

    onFinalizeSkuCreationProcess(
      response.pis_request_id,
      response.revision,
      response.finish_goods_no_assigned,
      username ? username : "",
      response.res_pm_market,
    );
    onSendPisRequestEmailsBasedOnAction(
      "APPROVED",
      response.pis_request_id,
      Number(response.revision),
      username ?? "",
      response.finish_goods_no_assigned,
    );

    onNavigate(`/mpn/requests`);
  } else {
    toast.error(
      "An error occurred. It was not possible to approve the PIS Request.",
    );
  }
}